$(document).ready(function(){ 
  var slider = $(".image_with_text_slider").owlCarousel({
      loop: true,
      responsiveClass: true,
      autoplay: true,
      dots: false, // Disable default dots since we'll use custom pagination
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items: 1 // Show one item at a time
  });
  
  // Custom navigation and pagination
  function updateCustomPagination(event) {
      var totalSlides = event.item.count; // Total number of slides
      var currentIndex = event.item.index - event.relatedTarget._clones.length / 2 + 1; // Current slide (1-based index)
  
      // Handle looping index
      if (currentIndex > totalSlides) {
          currentIndex = currentIndex - totalSlides;
      }
      if (currentIndex <= 0) {
          currentIndex = totalSlides + currentIndex;
      }
  
      // Update the custom pagination display
      $('.current-slide').text(currentIndex);
      $('.total-slides').text(totalSlides);
  }
  
  // Update the pagination when the slider is initialized or changed
  slider.on('initialized.owl.carousel changed.owl.carousel', updateCustomPagination);
  
  // Custom prev/next buttons
  $('.prev').click(function() {
      slider.trigger('prev.owl.carousel');
  });
  
  $('.next').click(function() {
      slider.trigger('next.owl.carousel');
  });
/*
  $(".image_with_text_slider").on('wheel', function(e) {
    if (e.originalEvent.deltaY > 0) { 
      slider.trigger('next.owl.carousel');
    } else { 
      slider.trigger('prev.owl.carousel');
    }
    e.preventDefault();  
  });
  */
});
